const clearLocalStorage = (): void => {
  const storedRememberId = localStorage.getItem("rememberId");
  const storedIsRemember = localStorage.getItem("isRemember");
  localStorage.clear();

  if(storedRememberId) localStorage.setItem("rememberId", storedRememberId);
  if(storedIsRemember) localStorage.setItem("isRemember", storedIsRemember);
}

export default clearLocalStorage;